<mat-toolbar class="tool-bar" *ngIf="hideNav">
    <mat-toolbar-row fxLayout="row">
        <button mat-icon-button (click)="close()"><mat-icon>menu</mat-icon></button>
        <span fxHide fxShow.gt-sm>User Management</span>
        <span class="example-spacer"></span>
        <div class="select" fxHide fxShow.gt-sm>
            <mat-form-field>
                <mat-select [(value)]="selected">
                    <mat-option *ngFor="let lang of languages" [value]="lang.code">
                        {{lang.language}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
        <div fxLayoutAlign="center end" class="header-user">

            <button mat-button [matMenuTriggerFor]="menu" class="menu-button">
                            <mat-icon class="example-icon" aria-hidden="false" aria-label="user verified icon">
                                <i class="material-icons header-user-person-icon">  person</i>
                            </mat-icon></button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item>
                                    <mat-icon>lock</mat-icon>
                                    <span>Change password</span>
                                </button>
                <button mat-menu-item>
                                    <mat-icon>info</mat-icon>
                                    <span>About PropCentra</span> </button>
                <button mat-menu-item>
                                    <mat-icon>power_settings_new</mat-icon>
                                    <span>Logout</span></button>
            </mat-menu>
        </div>
    </mat-toolbar-row>
</mat-toolbar>